<template>
  <div class="sale-areaDB-box">
    <div>
      <span style="border-right:1px solid blue;width:15rem" class="trend-title">区域</span>
      <span style="border-right:1px solid blue;width:10rem" class="trend-title">去年销量</span>
      <span style="width:10rem" class="trend-title">今年销量</span>
      <!-- <el-button size="mini"  @click="addArea" style="margin-left:1rem" type="primary" icon="el-icon-plus"></el-button> -->
      <i @click="addArea" class="el-icon el-icon-circle-plus-outline f_green"></i>
    </div>
    <div v-for="(item,index) in areaDate" :key="index" class="sale-areaDB">
        <el-input show-word-limit type="text" maxlength="20" placeholder="请输入" v-model="item.area"></el-input>
        <el-input type="number" v-model="item.saleDataLast">
          <template slot="suffix">万元</template>
        </el-input>
        <el-input type="number" v-model="item.saleData">
          <template slot="suffix">万元</template>
        </el-input>
        <!-- <el-button @click="removeArea(item.id,index)" style="margin-left:1rem" type="primary" icon="el-icon-minus"></el-button> -->
        <i @click="removeArea(item.id,index)" class="el-icon el-icon-remove-outline f_red"></i>
    </div>
    <div class="last-save">
      <el-button :loading="areaLoading" size="small" @click="saveDB" type="primary">保存</el-button>
    </div>
  </div>
</template>

<script>
import api from '@/apis/sale/sale'
export default {
  data(){
    return{
      areaLoading:false,//加载状态
      areaDate:[
        {area:'',saleDataLast:'',saleData:''}
      ]
    }

  },
  mounted(){
    this.getDB()
  },
  methods:{
    //保存数据
    saveDB(){
      this.areaLoading = true;
      api.saveArea(this.areaDate).then(res=>{
        if(res.code==10000){
          this.areaLoading = false;
          this.getDB()
          this.$message.success('保存成功')
        }else{
          this.$message.error(res.message);
          this.areaLoading = false;
          return;
        }
      })
    },
    //获取数据
    getDB(){
      api.getArea().then(res=>{
        if(res.code==10000){
          if(res.data){
            this.areaDate = res.data.list
          }
        }
      })
    },
    //删除一行对比
    removeArea(id,index){
      if(id){
        this.$confirm('确认删除, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          api.delArea([id]).then(res=>{
            if(res.code==10000){
              this.$message({
                type: 'success',
                message: '删除成功!'
              });
              this.getDB()
            }else{
              this.$message.error(res.message);
              return;
            }
          })
        })
      }else{
        this.areaDate.splice(index,1)
      }
    },
    //增加一行对比
    addArea(){
      this.areaDate.push({area:'',saleDataLast:'',saleData:''})
    },
  }
}
</script>
<style lang="less" scoped>
.sale-areaDB-box{ padding-top:10px;
  .trend-title{ text-align: center;}
  i{ font-size: 1.2rem; font-weight: bold; margin-left: 1rem; vertical-align: middle;}
  .sale-areaDB{
    .el-input{ width: 10rem;}
    .el-input:nth-child(1){ width: 15rem;}
  }
}
</style>